import styles from './Depoimentos.module.scss'
import erica from '../../assets/images/optimized/avatar-erica.webp'
import rovena from '../../assets/images/optimized/avatar-rovena.webp'
import bianca from '../../assets/images/optimized/avatar-bianca.webp'

const TESTIMONIALS = [
  {
    photo: erica,
    name: 'Érica, mãe do José',
    quote:
      'Quando meu filho iniciou a terapia com a Francis ele sequer pronunciava uma frase de forma que fosse possível entender e hoje ele consegue se comunicar muito bem. A cada sessão notamos seu progresso. Profissional excelente e confiável, serei eternamente grata.',
  },
  {
    photo: rovena,
    name: 'Rovena, mãe do Nícolas',
    quote:
      'Quem diria que tratamento com fonoaudióloga online seria possível? É possível e super válido! A evolução do meu filho é uma coisa linda de ver. As sessões são dinâmicas e lúdicas, a criança aprende brincando. Super indico e aprovo o trabalho da Tia Francis.',
  },
  {
    photo: bianca,
    name: 'Bianca, mãe da Diana',
    quote:
      'As sessões são dinâmicas e a Tia Francis tem jogo de cintura quando minha filha apresenta rigidez — possui TEA. Mesmo de longe sentimos sua dedicação, profissionalismo e amor com os pacientes. Estamos em um processo contínuo de evolução. Gratidão.',
  },
]

const Depoimentos = () => (
  <section id="depoimentos" className={styles.section}>
    <div className={styles.inner}>
      <h2>Depoimentos de Pacientes</h2>

      <div className={styles.cards}>
        {TESTIMONIALS.map(item => (
          <article key={item.name} className={styles.card}>
            <i className={`material-icons ${styles.quoteIcon}`}>format_quote</i>
            <p className={styles.quote}>{item.quote}</p>
            <div className={styles.author}>
              <img
                src={item.photo}
                alt={item.name}
                width={46}
                height={46}
                loading="lazy"
                decoding="async"
              />
              <span>{item.name}</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default Depoimentos
